class GrindOptions extends HTMLElement {
    constructor() {
        super();
        this.btnEventListeners();
        this.radioBtnOnChange();

        this.selectedCategory = undefined;
        this.selectedSubCategory = undefined;
    }

    btnEventListeners() {
        const grindElements = this.grindComponents();

        grindElements.grindElements.forEach((item) => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                item.querySelector('input').checked = true;
                // this.selectedCategory = item.querySelector('input').value;

                grindElements.grindElements.forEach(item => {
                    item.querySelector('img').removeAttribute('style');
                })

                //Hide all subcategories
                document.querySelectorAll('.grind-guide-exctra-options').forEach(option => {
                    option.classList.add('hidden');
                    //Uncheck everything
                    option.querySelectorAll('input').forEach(checkbox => {
                        checkbox.checked = false;
                    })
                })
                if(item.dataset.open == 'true') {
                    let targetElement = document.querySelector(`#${item.dataset.target}`);
                    if(targetElement.classList.contains('hidden')) {
                        targetElement.classList.remove('hidden');
                        targetElement.querySelector('input').checked = true;
                    } else {
                        targetElement.classList.add('hidden');
                        item.querySelector('input').checked = false;
                    }
                }
            })
        });
    }

    radioBtnOnChange() {
        const { grindElements, allExtraOptionElements } = this.grindComponents();

        grindElements.forEach(element => {
            element.addEventListener('click', () => {
                this.resetSubelementsColour();
                if(element.querySelector('input').checked) {
                    this.selectedCategory = element.querySelector('input').value;
                    //If selected option contains subcategories
                    if(element.dataset.open) {
                        let subcategories = document.querySelector(`#${element.dataset.target}`);
                        this.selectedSubCategory = subcategories.querySelector('input:checked').value;
                    } else {
                        this.selectedSubCategory = undefined;
                    }
                }
                this.updateProductProperties();
            })
        });

        allExtraOptionElements.forEach(element => {
            element.addEventListener('click', () => {
                if(element.querySelector('input').checked) {
                    this.selectedSubCategory = element.querySelector('input').value;
                    this.resetSubelementsColour();
                }
                this.updateProductProperties();
            })
        })
    }

    resetSubelementsColour() {
        const { allExtraOptionElements } = this.grindComponents();
        allExtraOptionElements.forEach(element => {
            element.querySelector('img').style = null
        })
    }

    updateProductProperties() {
        const { grindBuyNowProp } = this.grindComponents();

        let grindProperty = `${ this.selectedCategory }`;
        if(this.selectedSubCategory != undefined) {
            grindProperty = `${ this.selectedCategory } -> ${ this.selectedSubCategory }`;
        }
        grindBuyNowProp.value = grindProperty;

    }

    grindComponents() {
        const grindElements = this.querySelectorAll('.grind-option-element');
        const extraOptions = this.querySelector('.grind-guide-exctra-options');
        const allExtraOptionElements = this.querySelectorAll('.grind-guide-extra-input');
        const grindBuyNowProp = document.getElementById('product-buyNow-form-grind');

        return { grindElements, extraOptions, allExtraOptionElements, grindBuyNowProp }
    }
}

customElements.define("grind-options", GrindOptions);

class ProductGallery extends HTMLElement {
    constructor(initState = true) {
        super();
        if(initState) { this.initState(); }
    }
    
    initState() {
        const { statsOutOf, thumbnails } = this.galleryComponents();
        if(thumbnails.length > 0) {
            this.btnClickEvents();
            this.updateArrows();
            statsOutOf.textContent = thumbnails.length;
        }
    }

    btnClickEvents() {
        const {thumbnails, leftArrow, rightArrow } = this.galleryComponents();
        thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener('click', () => {
                this.clearActiveState();
                thumbnail.classList.add('active-slide');
                this.updateArrows();
                this.updateStatistics();
            });
        });
        leftArrow.addEventListener('click', () => {
            this.moveSlider('left');
        });
        rightArrow.addEventListener('click', () => {
            this.moveSlider('right');
        });
    }

    moveSlider(state) {
        const { thumbnailsContainer } = this.galleryComponents();
        let currentActive = this.querySelector('.active-slide');

        //Check if we can move left or right
        if(state == 'left' && parseInt(currentActive.dataset.slideid) == 1) {
            return;
        } else if(state == 'right' && parseInt(currentActive.dataset.slideid) == this.querySelectorAll('.slider_thumbnail').length) {
            return;
        }

        let nextActive;
        if(state == 'left') {
            nextActive = document.querySelector(`#product-image-${ parseInt(currentActive.dataset.slideid) - 1 }`);
        } else {
            nextActive = document.querySelector(`#product-image-${ parseInt(currentActive.dataset.slideid) + 1 }`);
        }

        nextActive = nextActive.querySelector('img');
        this.clearActiveState();
        nextActive.classList.add('active-slide');
        this.updateStatistics();
        this.updateArrows();


        const activeImageLeft = nextActive.offsetLeft;
        const containerScrollLeft = activeImageLeft - (thumbnailsContainer.offsetWidth / 2) + (nextActive.offsetWidth / 2);

        thumbnailsContainer.scrollTo({
            left: containerScrollLeft,
            behavior: 'smooth', // This enables smooth scrolling
          });

    }
    
    moveToPosition(position) {
        const { thumbnailsContainer } = this.galleryComponents();
        let nextActive = thumbnailsContainer.querySelector(`#product-image-${ position }`);
        if(!nextActive) return;

        this.clearActiveState();
        nextActive.querySelector('img').classList.add('active-slide');
        this.updateStatistics();
    }

    clearActiveState() {
        const { thumbnails } = this.galleryComponents();
        thumbnails.forEach(thumbnail => {
            thumbnail.classList.remove('active-slide');
        });
    }

    updateArrows() {
        const { thumbnails, leftArrow, rightArrow } = this.galleryComponents();
        let currentActive = this.querySelector('.active-slide');
        let currentIndex = parseInt(currentActive.dataset.slideid);

        if(currentIndex == 1) {
            leftArrow.classList.replace('text-darkGray', 'text-darkGray-1');
        } else if (currentIndex == thumbnails.length) {
            rightArrow.classList.replace('text-darkGray', 'text-darkGray-1');
        } else {
            leftArrow.classList.replace('text-darkGray-1', 'text-darkGray');
            rightArrow.classList.replace('text-darkGray-1', 'text-darkGray');
        }
    }

    updateStatistics() {
        const { currentlyShowing, featuredImages } = this.galleryComponents();
        let activeSlide = document.querySelector('.active-slide');
        let currentIndex = activeSlide.dataset.slideid;

        featuredImages.forEach(image => {
            image.parentElement.classList.remove('block');
            image.parentElement.classList.add('hidden');
        })

        const mainImage = document.querySelector(`#gallery-image-${ currentIndex }`);
        mainImage.classList.remove('hidden');

        currentlyShowing.textContent = currentIndex;
    }

    galleryComponents() {
        const featuredImages = document.querySelectorAll('.featured_image');
        const thumbnailsContainer = document.querySelector('#thumbnails_container');
        const thumbnails = document.querySelectorAll('.slider_thumbnail');
        const currentlyShowing = document.querySelector('#currently-showing');
        const statsOutOf = document.querySelector('#out-of');
        const leftArrow = this.querySelector('.slider-arrow-left');
        const rightArrow = this.querySelector('.slider-arrow-right');

        return { statsOutOf, currentlyShowing, leftArrow, rightArrow, featuredImages, thumbnailsContainer, thumbnails };

    }
}

customElements.define('product-gallery', ProductGallery);

class ProductQuantity extends HTMLElement {
    constructor() {
        super();
        this.initState();
    }

    initState() {
        const { quantityInput, quantityMinus, quantityPlus } = this.quantityComponents();
        this.updateQuantity();
        quantityInput.addEventListener('change', () => {
            this.updateQuantity();
        });
        quantityMinus.addEventListener('click', () => {
            this.updateQuantity('minus');
        });
        quantityPlus.addEventListener('click', () => {
            this.updateQuantity('plus');
        });
    }

    updateQuantity(state) {
        const { quantityInput } = this.quantityComponents();
        let currentQuantity = parseInt(quantityInput.value);
        if(state == 'minus') {
            if(currentQuantity > 1) {
                quantityInput.value = currentQuantity - 1;
            }
        } else if(state == 'plus') {
            quantityInput.value = currentQuantity + 1;
        }
    }

    quantityComponents() {
        const quantityInput = this.querySelector('#product-quantity');
        const quantityMinus = this.querySelector('#product-quantity-minus');
        const quantityPlus = this.querySelector('#product-quantity-plus');

        return { quantityInput, quantityMinus, quantityPlus };
    }
}

customElements.define('product-quantity', ProductQuantity);

class ProductVariant extends HTMLElement {
    constructor() {
        super();
        this.btnEventListeners();
        this.productGallery = new ProductGallery(false); // Don't init gallery buttons

        this.updateOptions();
        this.updateMasterId();
        this.updateGrindOptions();
    }

    btnEventListeners() {
        const { variantSelectors } = this.variantComponents();
        variantSelectors.forEach(selector => {
            selector.addEventListener('click', () => {
                this.uncheckAllRelatedInputs(selector.name);
                selector.classList.add('active');
                this.onVariantChange();
            })
        })
    }

    uncheckAllRelatedInputs(name) {
        this.querySelectorAll(`input[name="${name}"]`).forEach(input => {
            input.classList.remove('active');
        });
    }

    updateCartButtons(available) {
        const { AddToCartBtns, productSoldOut } = this.variantComponents();
        available ? AddToCartBtns.classList.remove('hidden') : AddToCartBtns.classList.add('hidden');
        available ? productSoldOut.classList.add('hidden') : productSoldOut.classList.remove('hidden');
    }

    updateProductPrice() {
        const { productPrice, productDiscountedPrice, cartCurrency } = this.variantComponents();

        //Detect if we have discount for this product and render section for it
        if(this.currentVariant.compare_at_price != null && this.currentVariant.compare_at_price != 0) {
            productPrice.classList.add('hidden');
            productDiscountedPrice.classList.remove('hidden');

            productDiscountedPrice.querySelector('#price-compare-at').textContent = formatMoney(this.currentVariant.compare_at_price, cartCurrency);
            productDiscountedPrice.querySelector('#discounted-price').textContent = formatMoney(this.currentVariant.price, cartCurrency);

        } else {
            productDiscountedPrice.classList.add('hidden');
            productPrice.classList.remove('hidden');
            productPrice.querySelector('#product-price-amount').textContent = formatMoney(this.currentVariant.price, cartCurrency);

        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    updateMasterId() {
        const { updateVariantId } = this.variantComponents();
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });

        updateVariantId.forEach(variantBtn => {
            variantBtn.setAttribute('data-variantid', this.currentVariant.id);
        })
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('input.active'), (select) => select.value);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({ }, '', `${window.location.pathname}?variant=${this.currentVariant.id}`);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateProductPrice();
        this.updateCartButtons(this.currentVariant.available);
        this.updateURL();
        this.switchToVariantImage(this.currentVariant.featured_image);
        this.updateGrindOptions();
    }

    switchToVariantImage(featuredImage) {
        if(featuredImage === null || featuredImage === undefined) return;
        console.log(`Switch to: ${featuredImage.position}`);
        this.productGallery.moveToPosition(featuredImage.position);
    }

    updateGrindOptions() {
        const availableGrindOptions = document.getElementById('grind-variants-available');
        if(availableGrindOptions == null || availableGrindOptions == undefined) return;

        const activeVariantGrinds = availableGrindOptions.querySelectorAll('div');

        //No grind goudes assigned to variants
        if(activeVariantGrinds.length == 0) return;
        //Check if variant has any options assigned to it.
        this.showAllGrindOptions(false); //Hide all grind options
        let totalVariantGrinds = 0;
        activeVariantGrinds.forEach(option => {
            if(option.dataset.variant == this.currentVariant.id) {        
                let grindOption = document.getElementById(option.dataset.grind);
                if(grindOption == null || grindOption == undefined) {
                    this.showAllGrindOptions();
                    return;
                }

                grindOption.parentElement.classList.remove('hidden');
                grindOption.click();
                grindOption.checked = true;
                totalVariantGrinds++;
            }
        });
        // Else show all grind guides
        if(totalVariantGrinds == 0) {
            this.showAllGrindOptions();
        }
    }

    //Hide or show all grind options
    showAllGrindOptions(show = true) {
        const allGrindGuides = document.getElementById('product-grind-options');
        allGrindGuides.querySelectorAll('li').forEach(option => {
            show ? option.classList.remove('hidden') : option.classList.add('hidden');
        });
    }

    variantComponents() {
        const variantSelectors = this.querySelectorAll('.variant-selector');
        const updateVariantId = this.querySelectorAll('.update-variant-id');
        const productJson = this.querySelector('script[type="application/ld+json"]');

        const AddToCartBtns = this.querySelector('#add-to-cart-btns');
        const productSoldOut = this.querySelector('#product-sold-out');
        const productPrice = this.querySelector('#product-price');
        const productDiscountedPrice = this.querySelector('#discounted-product')
        const cartCurrency = document.getElementById('cartCurrency').dataset.currency;

        return { variantSelectors, updateVariantId, productJson, AddToCartBtns, productSoldOut, productPrice, productDiscountedPrice, cartCurrency }
    }
}

customElements.define('product-variants', ProductVariant);
